module.exports = __webpack_public_path__ + "img/news-pic-preview.png?3b8e4c122ee84e91ca64a4072cc9da88";